import { Component, OnInit, Input, ViewChild } from '@angular/core'
import { AutomationTypes, AutomationViewGroup } from '@tokeet-frontend/automations'
import { AutomationsTableComponent } from '../automations-table/automations-table.component'
import { ReviewAutomationOverlayComponent } from './automation-overlay/review-automation-overlay.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-review-automations',
  templateUrl: './review-automations.component.html',
  styleUrls: ['./review-automations.component.scss'],
})
export class ReviewAutomationsComponent implements OnInit {
  @ViewChild(AutomationsTableComponent) table: AutomationsTableComponent

  @Input() showActions = false
  @Input() viewType: 'list' | 'grid' = 'grid'
  type = AutomationTypes.Review
  constructor(private dialog: DialogService) {}

  ngOnInit(): void {}

  onAdd() {
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
    })
  }

  onEdit(automation: AutomationViewGroup) {
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
      data: {
        automationGroup: automation,
      },
    })
  }
  onDuplicate(automation: AutomationViewGroup) {
    this.dialog.openDrawer(ReviewAutomationOverlayComponent, {
      panelClass: 'drawer-full-80',
      data: {
        automationGroup: automation,
        duplicate: true,
      },
    })
  }
}
